import Config from "./config";
import { NetworkHelper } from "clariant-helpers-vue3";

var DataLayer = {
    getCountries() {
        return new Promise((resolve, reject) => {
            NetworkHelper.get(`${Config.wsRootUrl}/locations/countries${Config.isDevEnvironment?".json" : ""}`)
                .then(res => {
                    let countries = [];
                    if (!res || !res.data || res.data.length === -1) reject("The list of countries received from the server is empty!");
                    else{ 
                        res.data.map(c => {
                            countries.push({...c, firstLetter: (c.displayName || c.name)[0].toUpperCase()});
                        });
                        resolve(countries);
                    }
                })
                .catch (err => {
                    reject(err);
                });
        });
    },
    getCountryInfo(name) {
        if (!name) return Promise.reject("Invalid name for a country! Try again!");
        return NetworkHelper.get(`${Config.wsRootUrl}/locations/country/${Config.isDevEnvironment ? "country.json" : encodeURIComponent(name)}`);
    },
    getLocations() {
        return NetworkHelper.get(`${Config.wsRootUrl}/locations${Config.isDevEnvironment?".json" : ""}`);
    },
    getLabels() {
        return NetworkHelper.get(`${Config.wsRootUrl}/commontexts/group?id=${Config.contactFormTextsRoot}`);
    },
    submitForm(payload) {
        if (!payload) return Promise.reject({ message: "Cannot submit an empty contact form!" });
        let url = `${Config.wsRootUrl}/locations/contact`
        return NetworkHelper.post(url, payload);
    }
};

export default DataLayer;